import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Marks a saved filter as just-used (updates `lastUsedAt` server-side).
 *
 * Idempotent and fire-and-forget — clients should not block on this.
 *
 * @param instance - Ky HTTP instance.
 * @param id - Saved filter id.
 */
export const touchSavedFilterLastUsed = async (instance: KyInstance, id: string) => {
  try {
    return await instance
      .patch<OperationResult>(formatString(Uri.savedFilters.lastUsed, id))
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
